export const EMPTY_FORM = {
  id: null,
  kickoffLocal: '',
  homeTeam: 'Danmark',
  awayTeam: '',
  competition: '',
  venue: '',
  city: '',
  homeScore: '',
  awayScore: '',
}

export const COMPETITIONS = [
  'Venskabskamp',
  'VM-kvalifikation',
  'EM-kvalifikation',
  'UEFA Nations League',
  'VM (slutrunde)',
  'EM (slutrunde)',
]

export const DEFAULT_TEAMS = [
  'Danmark',
  'Sverige',
  'Norge',
  'Finland',
  'Island',
  'Tyskland',
  'Frankrig',
  'Spanien',
  'Italien',
  'Portugal',
  'England',
  'Skotland',
  'Irland',
  'Holland',
  'Belgien',
  'Schweiz',
  'Østrig',
  'Polen',
  'Tjekkiet',
  'Slovakiet',
  'Ungarn',
  'Slovenien',
  'Kroatien',
  'Serbien',
  'Ukraine',
  'Grækenland',
  'Tyrkiet',
  'Rumænien',
  'Bulgarien',
  'Georgien',
  'Armenien',
  'Aserbajdsjan',
  'Israel',
  'Nordmakedonien',
  'Albanien',
  'Bosnien-Hercegovina',
  'Montenegro',
  'Letland',
  'Litauen',
  'Estland',
]

export const TEAMS_BY_COMPETITION = {
  'Venskabskamp': DEFAULT_TEAMS,
  'UEFA Nations League': DEFAULT_TEAMS,
  'EM-kvalifikation': DEFAULT_TEAMS,
  'VM-kvalifikation': [
    ...DEFAULT_TEAMS,
    'USA',
    'Canada',
    'Mexico',
    'Brasilien',
    'Argentina',
    'Uruguay',
    'Colombia',
    'Chile',
    'Japan',
    'Sydkorea',
    'Australien',
    'Iran',
    'Saudi-Arabien',
    'Marokko',
    'Tunesien',
    'Algeriet',
    'Senegal',
    'Nigeria',
    'Ghana',
    'Sydafrika',
    'Egypten',
  ],
  'EM (slutrunde)': DEFAULT_TEAMS,
  'VM (slutrunde)': [
    ...DEFAULT_TEAMS,
    'USA',
    'Canada',
    'Mexico',
    'Brasilien',
    'Argentina',
    'Uruguay',
    'Japan',
    'Sydkorea',
    'Australien',
    'Marokko',
    'Senegal',
    'Nigeria',
    'Ghana',
  ],
}

export const STADIUM_BY_HOME_TEAM = {
  Danmark: { venue: 'Parken', city: 'København' },
  Sverige: { venue: 'Friends Arena', city: 'Solna' },
  Norge: { venue: 'Ullevaal Stadion', city: 'Oslo' },
  Finland: { venue: 'Olympiastadion', city: 'Helsinki' },
  Island: { venue: 'Laugardalsvöllur', city: 'Reykjavík' },

  England: { venue: 'Wembley Stadium', city: 'London' },
  Skotland: { venue: 'Hampden Park', city: 'Glasgow' },
  Irland: { venue: 'Aviva Stadium', city: 'Dublin' },

  Tyskland: { venue: 'Allianz Arena', city: 'München' },
  Frankrig: { venue: 'Stade de France', city: 'Saint-Denis' },
  Spanien: { venue: 'Santiago Bernabéu', city: 'Madrid' },
  Italien: { venue: 'Stadio Olimpico', city: 'Rom' },
  Portugal: { venue: 'Estádio da Luz', city: 'Lissabon' },
  Holland: { venue: 'Johan Cruijff ArenA', city: 'Amsterdam' },
  Belgien: { venue: 'Koning Boudewijnstadion', city: 'Bruxelles' },
  Schweiz: { venue: 'St. Jakob-Park', city: 'Basel' },
  Østrig: { venue: 'Ernst-Happel-Stadion', city: 'Wien' },
  Polen: { venue: 'PGE Narodowy', city: 'Warszawa' },
  Tyrkiet: { venue: 'Atatürk Olimpiyat Stadı', city: 'Istanbul' },
  Grækenland: { venue: 'OPAP Arena', city: 'Athen' },
}

